module.exports = __webpack_public_path__ + "img/develop-skill.dd0f0978.jpg";